export default "__VITE_ASSET__D8R7iS1x__"